import { type ReactElement } from 'react'
import { type AttachmentId } from '@terros/common'
import { type TListItemProps, TListItem } from '../terros'
import { ViewAttachment } from './ViewAttachment'

type AttachmentProps = {
  attachmentId: AttachmentId
} & TListItemProps

export const AttachmentListItem = ({ attachmentId, ...props }: AttachmentProps): ReactElement => {
  return (
    <TListItem {...props}>
      <ViewAttachment attachmentId={attachmentId} />
      {props.children}
    </TListItem>
  )
}
